import { useEffect, useState } from 'react';
import ButtonBack from './images/x.png';
import ANTLotteryIcon from "./images/LotteryTicket.png";
import ANTFoodIcon from "./images/AntFood.png";
import LevelingPotionIcon from "./images/LevelingPotion.png";
import CommonOpenImg from './images/shop_img_chest_open01_l_00.png';
import UnCommonOpenImg from './images/shop_img_chest_open01_l_02.png';
import RareOpenImg from './images/shop_img_chest_open01_l_03.png';
import UltraRareOpenImg from './images/shop_img_chest_open01_l_04.png';
import LegendaryOpenImg from './images/shop_img_chest_open01_l_05.png';

const rewardItemIcons = [
  {icon: ANTLotteryIcon, name:"Lottery Ticket"},
  {icon: ANTFoodIcon, name:"Ant Food"},
  {icon: LevelingPotionIcon, name:"Leveling Potion"},
];

function PurseOpenPopup({ rewardedData, rewardInfo, onClose }) {
  // You can utilize rewardInfo for other purposes as needed
  const [rewardItemIcon, setRewardItemIcon] = useState(undefined)
  const [rewardItemName, setRewardItemName] = useState("")
  const [ rewwardItemAmount, setRewardItemAmount] = useState(0)

  const chestImages = {
    Common: CommonOpenImg,
    Uncommon: UnCommonOpenImg,
    Rare: RareOpenImg,
    UltraRare: UltraRareOpenImg,
    Legendary: LegendaryOpenImg,
  };

  // const rewardItemIcon = rewardItemIcons[rewardInfo.rewardType];
  const openChestImage = chestImages[rewardInfo.name]; // Use the 'name' property to determine which chest image to use

  useEffect(()=>{
    if(rewardedData.token === 0) return;
    setRewardItemIcon(rewardItemIcons[rewardedData.token-1].icon)
    setRewardItemAmount(rewardedData.amount)
    setRewardItemName(rewardItemIcons[rewardedData.token-1].name)
  },[rewardedData])
  return (
    <div className="popup-container">
      <div className="popup">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} alt="Close button" />
        </button>
        <div className="popup-content-left" id="purseopen-left">
        <div className="popupimage-holder" id="purseopen-image-holder">
            <img src={openChestImage} alt="Open Purse" />
          </div>
        </div>
        <div className="popup-content-right" id="purseopen-right">
          <h2>ITEMS RECEIVED</h2>
        <div className="popupinfo-holder" id="purseopen-info">
            <div className="info-box" id="purseopen-info-box">
              <img src={rewardItemIcon} alt="Reward Item" />
              <p>{rewwardItemAmount} {rewardItemName}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PurseOpenPopup;